import type { FaireProductEntity } from "../../entity_types/product";

export const p_fpngcgaf42: FaireProductEntity = {
  token: "p_fpngcgaf42",
  type: "product",
  name: "Christian Mom Sweatshirt - Mama's don't let your babies",
  brandToken: "b_ptxhxzu9rh",
  brandName: "Wholehearted Motherhood and Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0e8e7e15071032950f1395b1785023705f274ebe7f00f4f2b06009d731485cfd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33d199fb37b711bc483378f0c63586fe4bc7219a39db8024cbbaf285d7f61155.jpeg",
  ],
  priceDollars: 24.65,
  description:
    "Mama's Don't Let Your Babies Grow Up With Out Jesus Sweatshirt  - Faith Sweatshirt - Spring Tee - Summer Tee\n\nSuper Soft and Comfy Unisex 50/50 blend Crewneck Pullover.\n \nThis sweatshirt is super comfy and perfect for any season.\n \nThese are available in soft style Tees in our shop too!\n \nCare Instructions: We recommend washing inside out, cold water, gentle cycle. Tumble dry on low. Do not iron directly on design.",
  tags: [],
  msrpDollars: 49.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:44.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
